import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';
import { getAdultCheckUpHeReportList } from 'models/adultCheckUpReport';
import { getAdultCheckupOptionBySlug } from 'util/adultCheckupReportOptions';

const routes: CustomRoute = {
	path: '/:reportType',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'adultCheckupReportDetail' */ './component')],
			render: ([AdultCheckupReportDetail]) => <AdultCheckupReportDetail />,
			onEnter: async ({ store, next, pathname }) => {
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.ADULT_CHECKUP_REPORT}`);
				if (!allowEnter) {
					return false;
				}
				const basePath = `/${ROUTE_PATHS.EYE_REPORT}/${ROUTE_PATHS.ADULT_CHECKUP_REPORT}/`;
				const slug = pathname.startsWith(basePath)
					? pathname.slice(basePath.length).split('/')[0]
					: '';
				const option = getAdultCheckupOptionBySlug(slug);
				if (option) {
					await store.dispatch(getAdultCheckUpHeReportList(option.eyesHeType));
				}
				const children = await next();
				return children;
			},
		},
	],
};

export default routes;
